export class CentralNotificacaoDiaSemana{
    public id: number;
    public dia_semana: number;
    public id_central_notificacao: number;

    constructor(dia_semana: number, id_central_notificacao: number){
        this.id = null;
        this.dia_semana = dia_semana;
        this.id_central_notificacao = id_central_notificacao;
    }
}


// WEBPACK FOOTER //
// ./src/app/entity/central-notificacao-dia-semana.model.ts